import { Info } from "@mui/icons-material"
import { IconButton, Tooltip } from "@mui/material"
import { useState } from "react"

const UnitInfoButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <Tooltip
      open={open}
      onClose={() => setOpen(false)}
      title={
        <>
          <h4>Unit Format</h4>
          <p>
            This field will determines how numeric unit results from sampling will be formatted for
            the viewer in charts and data in Result screens, e.g. 20420.42 could be formatted as
            20,420 Tonnes
          </p>
          <h5>Examples</h5>
          <table border={0}>
            <thead>
              <tr>
                <th>Number</th>
                <th>Format</th>
                <th>Output</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>3.1415926</td>
                <td>{"{,.4f}"}</td>
                <td>3.1416</td>
              </tr>
              <tr>
                <td>3.1415926</td>
                <td>{"{,.4f} tonnes"}</td>
                <td>3.1416 tonnes</td>
              </tr>
              <tr>
                <td>2.71828</td>
                <td>{"{,.0f}"}</td>
                <td>3</td>
              </tr>
              <tr>
                <td>1000000</td>
                <td>{"{,.0f}"}</td>
                <td>1,000,000</td>
              </tr>
              <tr>
                <td>0.35</td>
                <td>{"{,.2%}"}</td>
                <td>35.00%</td>
              </tr>
              <tr>
                <td>333.7653</td>
                <td>BLANK</td>
                <td>333.7653</td>
              </tr>
            </tbody>
          </table>
        </>
      }
      arrow
      placement="top"
    >
      <IconButton onClick={() => setOpen(!open)}>
        <Info />
      </IconButton>
    </Tooltip>
  )
}

export default UnitInfoButton
